import { isArray } from "./any";

export const getFormError = (errors, string) => {
  if (!isArray(errors)) {
    return true;
  }
  for (let i = 0; i < errors.length; i += 1) {
    const e = errors[i];
    if (e.param === string) {
      return e.msg;
    }
  }
  return true;
};

export const getError = (err) => {
  if (err.msg) {
    return err.msg;
  }

  if (err.form) {
    return err.form;
  }

  return "Could not contact the server. Please try again later.";
};
